import { render, staticRenderFns } from "./AddonsForm.vue?vue&type=template&id=09c52062&"
import script from "./AddonsForm.vue?vue&type=script&lang=js&"
export * from "./AddonsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports